
import { Model, List } from './base'

class TechtalkVideo extends Model {
  get defaults() {
    return {
      id: '',
      snippet: {
        playlistId: '',
        title: '',
        resourceId: {
          videoId: ''
        },
        thumbnails: {
          high: {
            url: ''
          }
        }
      }
    }
  }

  get playlistUrl() {
    return `https://youtube.com/watch?v=${this.get('snippet.resourceId.videoId')}&list=${this.get('snippet.playlistId')}`
  }

  get thumbnailUrl() {
    return this.get('snippet.thumbnails.high.url')
  }

  get title () {
    return this.get('snippet.title')
  }
}

class TechtalkVideosList extends List {
  get model() {
    return TechtalkVideo
  }
}

export { TechtalkVideo, TechtalkVideosList }
